/** One personal rate: the amount, the day it starts, who set it and when. */
import type { PayRateEntry } from '../../../api/staff-pay-rates';

import { formatCalendarDate, formatRateCents, formatRecordedAt } from './pay-rate-format';
import PayRateRemoveControl from './PayRateRemoveControl';

export default function PayRateHistoryRow({
  entry,
  busy,
  onRemove,
}: {
  entry: PayRateEntry;
  busy: boolean;
  onRemove: (rateId: string) => void;
}) {
  return (
    <li className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <span className="w-20 font-medium text-bark-900 dark:text-stone-100">
        {formatRateCents(entry.amountCents)}
      </span>
      <span className="text-stone-700 dark:text-stone-300">
        From {formatCalendarDate(entry.effectiveFrom)}
      </span>
      {entry.startsInFuture && (
        <span className="text-xs px-1.5 py-0.5 rounded-full bg-water-50 dark:bg-water-900/20 text-water-700 dark:text-water-400">
          Scheduled
        </span>
      )}
      <span className="min-w-0 flex-1 text-xs text-stone-600 dark:text-stone-400">
        {entry.setBy ? `Set by ${entry.setBy.name}` : 'Rate sheet import'} ·{' '}
        {formatRecordedAt(entry.setAt)}
      </span>
      {entry.removable && <PayRateRemoveControl entry={entry} busy={busy} onRemove={onRemove} />}
    </li>
  );
}
